import { BUSINESS } from "../lib/constants";

export const LogoMark = ({ size = 34 }) => (
  <img
    src={BUSINESS.logo3d}
    alt="Everything Works Services 3D logo"
    width={size}
    height={size}
    className="rounded-xl object-cover shrink-0"
    style={{
      border: "1px solid rgba(0,229,255,0.35)",
      boxShadow: "0 4px 24px -6px rgba(0,229,255,0.5)",
    }}
    data-testid="logo-mark-3d"
  />
);

export const Logo = ({ compact = false }) => (
  <div className="flex items-center gap-3 select-none">
    <LogoMark />
    {!compact && (
      <div className="leading-none">
        <div className="font-display text-xl tracking-wide text-white">
          Everything Works
        </div>
        <div className="font-mono text-[10px] tracking-[0.35em] text-crystal mt-1 uppercase">
          Services · Naperville
        </div>
      </div>
    )}
  </div>
);

export default Logo;
